module.exports = __webpack_public_path__ + "img/icon_ok_green.d42eb085.svg";